import { baseApi } from "api/BaseApi";

import {
  PublicTechnicalDecision,
  PublicTechnicalDecisionTableItem,
} from "./technicalDecisions.types";

const PUBLIC_TD_BASE_QUERY = "technical-decision";

const publicTechnicalDecisionApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicTd: build.query<PublicTechnicalDecision, string>({
      query: (id) => `${PUBLIC_TD_BASE_QUERY}/frontend_by_identifier/${id}/`,
    }),

    getPublicTds: build.query<PublicTechnicalDecisionTableItem[], void>({
      query: () => ({
        url: `${PUBLIC_TD_BASE_QUERY}/frontend_tds/`,
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useGetPublicTdQuery, useGetPublicTdsQuery } =
  publicTechnicalDecisionApi;
